import { render, staticRenderFns } from "./productCenter.vue?vue&type=template&id=6b64716a&scoped=true"
import script from "./productCenter.vue?vue&type=script&lang=js"
export * from "./productCenter.vue?vue&type=script&lang=js"
import style0 from "./productCenter.vue?vue&type=style&index=0&id=6b64716a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b64716a",
  null
  
)

export default component.exports